import axiosInstance from "@/api/axiosInstance";
import {
  ApplyEnrollmentVoucherRequest,
  ApplyEnrollmentVoucherResponse,
} from "./types";

export const applyEnrollmentVoucher = async (
  requestData: ApplyEnrollmentVoucherRequest,
): Promise<ApplyEnrollmentVoucherResponse> => {
  const url = `/api/private/enrollments/${requestData.enrollmentId}/apply-voucher`;

  const response = await axiosInstance.post<ApplyEnrollmentVoucherResponse>(
    url,
    { voucherId: requestData.voucherId },
  );

  return response.data;
};
